var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteryFillerLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 64,
    viewBox: "0 0 41 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    clipPath: "url(#clip0_450_38053)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: 66,
    width: 66,
    height: 5,
    transform: "rotate(157 51 66)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: 53,
    width: 66,
    height: 5,
    transform: "rotate(157 51 53)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: 41,
    width: 66,
    height: 5,
    transform: "rotate(157 51 41)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: 28,
    width: 66,
    height: 5,
    transform: "rotate(157 51 28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: 16,
    width: 66,
    height: 5,
    transform: "rotate(157 51 16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: 4,
    width: 66,
    height: 5,
    transform: "rotate(157 51 4)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: -9,
    width: 66,
    height: 5,
    transform: "rotate(157 51 -9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51,
    y: -21,
    width: 66,
    height: 5,
    transform: "rotate(157 51 -21)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_38053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.707,
    height: 266.391,
    fill: "white",
    transform: "matrix(-1 0 0 -1 51 227.788)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryFillerLines);
export default __webpack_public_path__ + "static/media/batteryFillerLines.653d37ca20e7fd24b6af8f2453ca0a14.svg";
export { ForwardRef as ReactComponent };